module.exports = __webpack_public_path__ + "img/SEJ enventos_logo jalisco.9f87a7eb.svg";